import { useEffect, useState } from 'react'
import './adminDashboard.css'
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
    BarChart, Bar, ResponsiveContainer
} from 'recharts'
import { GET } from '../../utils/apicalls'
import { API } from '../../config/api'

function Admindashboard() {
    const [isLoading, setIsLoading] = useState(false);
    const [bookingData, setBookingData] = useState<any>({});

    const fetchAllBookingDetails = async () => {
        try {
            setIsLoading(true);
            const response: any = await GET(API.BOOKING_DETAILS_ADMIN, {});
            setBookingData(response?.data || {});
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchAllBookingDetails();
    }, []);

    return (
        <div className="dashboard">
            <h1>Admin Dashboard</h1>

            <div className="summary-cards">
                <div className="card">
                    <div className="card-content">
                        <span className="card-label">Total Courses</span>
                        <span className="card-value indigo">{bookingData.courses || 0}</span>
                    </div>
                </div>
                <div className="card">
                    <div className="card-content">
                        <span className="card-label">Total Revenue</span>
                        <span className="card-value green">₹{(bookingData.totalrevenue || 0).toLocaleString()}</span>
                    </div>
                </div>
                <div className="card">
                    <div className="card-content">
                        <span className="card-label">Total Bookings</span>
                        <span className="card-value blue">{bookingData.bookingData || 0}</span>
                    </div>
                </div>
                <div className="card">
                    <div className="card-content">
                        <span className="card-label">Total Payments</span>
                        <span className="card-value pink">{bookingData.totalPayments || 0}</span>
                    </div>
                </div>
            </div>

            <div className="charts">
                <div className="chart-card">
                    <h2>Monthly Revenue</h2>
                    <ResponsiveContainer width="100%" height={300}>
                        <LineChart data={bookingData.monthlyRevenue || []}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="month" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Line type="monotone" dataKey="revenue" stroke="#4f46e5" strokeWidth={3} />
                        </LineChart>
                    </ResponsiveContainer>
                </div>

                <div className="chart-card">
                    <h2>Weekly Bookings</h2>
                    <ResponsiveContainer width="100%" height={300}>
                        <BarChart data={bookingData.weeklyBookings || []}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="day" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="bookings" fill="#10b981" barSize={40} />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            </div>
        </div>
    )
}

export default Admindashboard
